import { render, staticRenderFns } from "./FriendlyFaces.vue?vue&type=template&id=24883a8f"
import script from "./FriendlyFaces.vue?vue&type=script&lang=ts"
export * from "./FriendlyFaces.vue?vue&type=script&lang=ts"
import style0 from "./FriendlyFaces.vue?vue&type=style&index=0&id=24883a8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports